AOS.init({ duration: 1000, once: true });

// Navbar shrink on scroll
window.addEventListener('scroll', function() {
  const nav = document.querySelector('.navbar');
  if(!nav) return;
  if (window.scrollY > 60) nav.classList.add('scrolled');
  else nav.classList.remove('scrolled');
});

// Simple demo search modal focus
(function(){
  const modalEl = document.getElementById('searchModal');
  if(!modalEl) return;
  modalEl.addEventListener('shown.bs.modal', () => {
    const input = modalEl.querySelector('input');
    if(input) input.focus();
  });
})();

// Demo cart badge + buttons
(function(){
  const badge = document.querySelector('.cart-badge');
  if(!badge) return;

  const updateBadge = (n) => {
    badge.textContent = String(n);
    badge.style.display = n > 0 ? 'inline-block' : 'inline-block';
  };

  let count = parseInt(badge.textContent || '0', 10) || 0;
  updateBadge(count);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if(!btn) return;
    
    count += 1;
    updateBadge(count);
    btn.classList.add('btn-success');
    btn.textContent = 'Added';
    setTimeout(() => {
      btn.classList.remove('btn-success');
      btn.textContent = 'Add to cart';
    }, 900);
  });
})();

// Catalog filter (Collections page)
(function(){
  const search = document.getElementById('catalogSearch');
  const category = document.getElementById('catalogCategory');
  if(!search && !category) return;

  const tiles = Array.from(document.querySelectorAll('[data-catalog-item]'));

  const normalize = (s) => (s || '').toLowerCase().trim();

  function apply(){
    const q = normalize(search ? search.value : '');
    const c = normalize(category ? category.value : '');

    tiles.forEach((el) => {
      const name = normalize(el.getAttribute('data-name'));
      const cat  = normalize(el.getAttribute('data-category'));

      const okName = !q || name.includes(q);
      const okCat  = !c || c === 'all' || cat === c;

      el.style.display = (okName && okCat) ? '' : 'none';
    });
  }

  if(search) search.addEventListener('input', apply);
  if(category) category.addEventListener('change', apply);

  apply();
})();